import React, { useState } from 'react'
import TableComponent from '../Components/TableComponent'
import baseUrl from '../config';

export default function TruBend7030() {
  const [modifiedData, setModifiedData] = useState([]);

  const api = `${baseUrl}/listResultsBending`
  return (
    <div>
      <TableComponent
        modifiedData={modifiedData}
        setModifiedData={setModifiedData}
        api={api}
        filterText="TRUBEND 7030"
      />
    </div>
  )
}
